import React from 'react';
import './App.css';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Services from './components/Services';
import PortfolioGrid from './components/PortfolioGrid';
import ContactForm from './components/ContactForm';
import Partners from './components/Partners';
import About from './components/About';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Services />
      <PortfolioGrid />
      <ContactForm />
      <Partners />
      <About />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;